module.exports = __webpack_public_path__ + "static/media/demo_video.345c91f4.mkv";